<template>
  <div class="dp_no_icon">
    <div @click="isClick">
      <el-date-picker
        type="daterange"
        :clearable="false"
        :editable="false"
        v-model="value1"
        :readonly="webReadonly"
        :range-separator="getNights + $t('DATEPICKER.NIGHT')"
        :placeholder="$t('DATEPICKER.FIRSTLABLE')"
        :data-val="getNights"
        @change="change"
        :disabled-date="disabledDate"
        class="datepicker"
      >
      </el-date-picker>
    </div>
    <div>
      <van-calendar
        :show ="calendarShow"
        type="range"
        @confirm="onConfirm"
        @close="calendarShow = false"
        :default-date="defaultDate"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="calFormatter"
        :max-range="maxRange"
        :range-prompt="rangePromptText"
        color="#fc6640"
      />
    </div>
    <ConfirmBoxs
      :centerDialogVisible="centerDialogVisible"
      :confirmMsg="confirmMsg"
      @setConfirmFlag="setConfirmFlag"
    ></ConfirmBoxs>
  </div>
</template>

<script>
import ConfirmBoxs from "../components/confirmBoxs.vue";
import { getServerTimeAxios, dateChange, formatDateTime } from "@/utils/utils.js";

export default {
  name: "datePicker",
  components: {
    ConfirmBoxs
  },
  props: {
    getDate: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      obj: null,
      checkInDate: "",
      getNights: "",
      value1: [],
      getDay: [],
      pickerOptions0: {},
      confirmMsg: "",
      centerDialogVisible: false,
      calendarShow: false,
      webReadonly: false,
      defaultDate: [],
      minDate: new Date("2022/01/01"),
      maxDate: new Date("2022/01/30"),
      maxRange: 30,
      tripNum: 0
    }
  },
  computed: {
    firstLable() {
      return this.$t("DATEPICKER.FIRSTLABLE")
    },
    lastLable() {
      return this.$t("DATEPICKER.LASTLABLE")
    },
    rangePromptText() {
      return this.$t('SEARCH.CHECKINOUTDATE', { maxDay: this.$objBaseInfo?.maxNights || 30 })
    }
  },
  methods: {
    toDateValue(value) {
      const date = new Date(value)
      return Number.isNaN(date.getTime()) ? null : date
    },
    syncDefaultDate(value) {
      if (Array.isArray(value) && value.length === 2) {
        const startDate = this.toDateValue(value[0])
        const endDate = this.toDateValue(value[1])
        if (startDate && endDate) {
          this.defaultDate = [startDate, endDate]
          return
        }
      }
      this.defaultDate = []
    },
    calFormatter(day) {
      if (day.type === "start") {
        day.bottomInfo = this.$t("DATEPICKER.CHECKIN")
      } else if (day.type === "end") {
        day.bottomInfo = this.$t("DATEPICKER.CHECKOUT")
      }
      return day
    },

    isClick() {
      if (this.$objBaseInfo?.channelId == "MOBILE") {
        this.calendarShow = true
      }
    },

    onConfirm(date) {
      this.calendarShow = false
      this.change(date)
    },

    setDatePicker() {
      if (this.$objBaseInfo) {
        getServerTimeAxios((res) => {
          let maxDay = this.$objBaseInfo.maximumDaysAdvance
          this.minDate = new Date(formatDateTime(res, "YYYY-MM-DD"))
          if (maxDay) {
            this.maxDate = new Date(dateChange(parseInt(maxDay), new Date(res)))
          } else {
            this.maxDate = new Date(dateChange(parseInt(360), new Date(res)))
          }
          this.pickerOptions0 = {
            disabledDate: (time) => {
              return (
                time.getTime() < new Date(res).getTime() - 3600 * 1000 * 24 * 1 ||
                time.getTime() > new Date(res).getTime() + parseInt(maxDay) * 1000 * 24 * 3600
              )
            },
          }
        })
      } else {
        if (this.tripNum < 20) {
          this.tripNum++
          setTimeout(() => {
            this.setDatePicker()
          }, 1000)
        }
      }
    },

    setConfirmFlag() {
      this.centerDialogVisible = false
    },

    getNight() {
      if (this.value1 && this.value1.length > 0) {
        const constNight =
          (new Date(this.value1[1]).getTime() -
            new Date(this.value1[0]).getTime()) /
          (24 * 60 * 60 * 1000)
        this.getNights = constNight
      } else {
        this.getNights = ""
      }
    },

    change(value) {
      if (value != null) {
        if (new Date(value[1]).getTime() == new Date(value[0]).getTime()) {
          this.confirmMsg = this.$t("SEARCH.CHECKINOUTDATE2")
          this.centerDialogVisible = true
          this.value1 = []
        } else {
          const nightsDiff = (new Date(value[1]).getTime() - new Date(value[0]).getTime()) / (3600 * 1000 * 24 * 1)
          if (nightsDiff > this.$objBaseInfo.maxNights || nightsDiff < 1) {
            this.value1 = []
            this.confirmMsg = this.$t("SEARCH.CHECKINOUTDATE", {
              maxDay: this.$objBaseInfo.maxNights,
            })
            this.centerDialogVisible = true
          } else {
            this.value1 = value
          }
        }
      }
      this.syncDefaultDate(this.value1)
    },

    initDOMOperations() {
      const keyNode = document.querySelector(".el-date-editor")
      if (!keyNode) return

      if (this.$objBaseInfo?.channelId == "WEB") {
        // 开始时间加标题
        let inputs = document.getElementsByClassName("el-range-input")
        if (inputs[0]) inputs[0].setAttribute("style", "text-align: left;")
        if (inputs[1]) inputs[1].setAttribute("style", "text-align: right;")
        
        let firstLable = document.createElement("div")
        firstLable.setAttribute("style", "position: relative")
        firstLable.innerHTML = `<div class="dp_first_lable">${this.firstLable}</div>`
        keyNode.insertBefore(firstLable, inputs[0])

        // 结束时间加标题
        let lastLable = document.createElement("div")
        lastLable.setAttribute("style", "position: relative")
        lastLable.innerHTML = `<div class="dp_last_lable">${this.lastLable}</div>`
        keyNode.insertBefore(lastLable, keyNode.lastChild)
      }

      // 删除icon
      let date_icons = document.getElementsByClassName("el-input__icon")
      if (date_icons[0]) {
        keyNode.removeChild(date_icons[0])
      }
    },

    updateLabels() {
      if (this.$objBaseInfo?.channelId == "WEB") {
        let fLabel = document.querySelector(".dp_first_lable")
        if (fLabel) fLabel.innerHTML = this.firstLable

        let lLabel = document.querySelector(".dp_last_lable")
        if (lLabel) lLabel.innerHTML = this.lastLable
      }
    },

    // 禁用日期函数
    disabledDate(time) {
      if (!this.$objBaseInfo) return false
      
      let maxDay = this.$objBaseInfo.maximumDaysAdvance || 360
      const oneDayMs = 86400000
      
      // 使用服务器时间或当前时间
      const baseTime = this.minDate ? this.minDate.getTime() : Date.now()
      
      // 禁用今天之前和最大天数之后的日期
      return (
        time.getTime() < baseTime - oneDayMs ||
        time.getTime() > baseTime + maxDay * oneDayMs
      )
    }
  },
  mounted() {
    this.setDatePicker()
    this.initDOMOperations()
    
    if (this.$objBaseInfo?.channelId == "MOBILE") {
      this.webReadonly = true
    } else {
      this.webReadonly = false
    }
    this.maxRange = this.$objBaseInfo?.maxNights || 30
  },
  updated() {
    this.updateLabels()
  },
  watch: {
    value1(newVal) {
      this.syncDefaultDate(newVal)
      this.$emit("getTimes", newVal)
    },
    getDate: {
      handler(newVal) {
        if (newVal && newVal.length === 2) {
          this.syncDefaultDate(newVal)
          this.change(newVal)
          this.getNight()
        } else {
          this.syncDefaultDate(newVal)
        }
      },
      immediate: true
    }
  }
}
</script>

<style lang="stylus" scoped>
:deep(.el-date-editor .el-range-separator) {
  width: 25%;
}
</style>

<style lang="stylus">
.dp_first_lable {
  position: absolute;
  top: -4rem;
  width: 6.5rem;
  height: 2rem;
  text-align: left;
}

.dp_last_lable {
  position: absolute;
  width: 6.5rem;
  top: -4rem;
  right: 0;
  text-align: right;
}

:deep(.el-input__inner) {
  height: 5rem;
  line-height: 5rem;
  background-color: #E7E9EA;
}
.datepicker {
  width: 94% !important;
  height: 5.2rem!important;
  line-height: 5rem!important;
  background-color: #E7E9EA!important;
}
</style>